import { Box, Flex, Icon, Spinner, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { FaEye } from "react-icons/fa";
import { useLang } from "../../../Hooks";
import { ReportHeader } from "../Shared/Components/ReportHeader";
import { ReportToolbar } from "../Shared/Components/ReportToolbar";
import { reportToolbarStyles } from "../Shared/Styles/reportToolbarStyles";
import { darkThemeStyles } from "../balanceSheetStyles";
import { AnalyticalLayersActions } from "./Components/AnalyticalLayersActions";
import { AnalyticalLayersFilters } from "./Components/AnalyticalLayersFilters";
import { AnalyticalLayersTree } from "./Components/AnalyticalLayersTree";
import { useAnalyticalLayersData } from "./hooks/useAnalyticalLayersData";

export default function AnalyticalLayers() {
  const { texts } = useLang();
  const {
    filters,
    isExporting,
    isLoadingReport,
    reportData,
    handleApplyFilters,
    handleCurrencyChange,
    handleExportReport,
  } = useAnalyticalLayersData(texts);

  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.innerHTML = darkThemeStyles;
    document.head.appendChild(styleElement);
    return () => document.head.removeChild(styleElement);
  }, []);

  return (
    <Box bg="var(--bg-primary)" p={0} display="flex" flexDirection="column" height="calc(100dvh - 3rem)" overflow="hidden">
      <Flex {...reportToolbarStyles.headerRow} flexShrink={0}>
        <ReportHeader
          title={texts?.reports?.analyticalLayers || "Analytical Layers"}
          subtitle={texts?.reports?.financialOverview || "Financial overview"}
        />
        <ReportToolbar
        >
          <AnalyticalLayersFilters
            currentCurrency={filters.currency}
            initialDate={filters.date}
            onApplyFilters={handleApplyFilters}
            onCurrencyChange={handleCurrencyChange}
            texts={texts}
          />
          <AnalyticalLayersActions
            isExporting={isExporting}
            onExport={handleExportReport}
            texts={texts}
          />
        </ReportToolbar>
      </Flex>
      <Box flex={1} minHeight={0} position="relative">
        {isLoadingReport ? (
          <Flex justify="center" align="center" h="100%">
            <Spinner size="xl" color="var(--accent-primary)" />
            <Text ml={3}>{texts.reports?.loadingReport || "Loading report..."}</Text>
          </Flex>
        ) : reportData?.treeData?.length ? (
          <AnalyticalLayersTree data={reportData} />
        ) : (
          <Box
            bg="white"
            borderRadius="lg"
            boxShadow="sm"
            border="1px solid"
            borderColor="#eaeef2"
            p={8}
            textAlign="center"
            height="100%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Icon as={FaEye} boxSize={10} color="var(--text-muted)" mb={4} />
            <Text fontSize="lg" mb={2}>
              {texts.reports?.noDataAvailable || "No data available"}
            </Text>
            <Text color="var(--text-muted)">
              {texts.reports?.tryChangingFilters || "Try changing your filters to see data"}
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
}
